import { ModalQuestionIco } from '@modules/CustomIcons'
import { useCustomModal } from '@shared/Modal'
import { t } from 'i18next'
import CustomResult from 'pages/BusinessCards/components/LimitsPage/utils/CustomResult'
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  limitsCardApi,
  useFetchByDocTypeMutation,
  useSetLimitForBusinnessCardMutation,
} from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { arrayBufferToBase64, AsanSigning, CompleteData } from '@shared/AsanSigning'
import moment from 'moment'
import { QueryStatus } from '@reduxjs/toolkit/query'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { useDispatch } from 'react-redux'

function AssignLimit() {
  const dispatch = useDispatch()
  const pan = useAppSelector((state) => state.employeePan.pan)
  const { closeModal, setStatus } = useCustomModal()
  const { getValues, trigger } = useFormContext()
  const [asanOpen, setAsanOpen] = useState(false)
  const [setLimitForBusinnessCard, { isError, isSuccess, status, error }] =
    useSetLimitForBusinnessCardMutation()

  async function setLimit({transactionId}: CompleteData) {
    closeModal()

    const isValid = await trigger()

    if (isValid) {
      const updateRequestData = getValues()

      setLimitForBusinnessCard({
        requestData: {
          ...updateRequestData,
          transactionId,
        },
      })
        .unwrap()
        .then(() =>
          setStatus({
            status: QueryStatus.fulfilled,
            message: t('businessCards.operationSuccessNote'),
          })
        )
        .catch((err) =>
          setStatus({ status: QueryStatus.rejected, message: err?.data })
        )
    }
  }

  return (
    <>
      <AsanSigning
        asanKey="LMT"
        docType="LMT"
        checkSignCallback={() => true}
        afterCloseFn={() => {
          isSuccess && dispatch(limitsCardApi.util.resetApiState())
        }}
        checkDirectorFnWithProps={[
          useFetchByDocTypeMutation,
          {
            isClickCardBlockButton: false,
            docType: 'LMT',
          },
        ]}
        defaultOpen={[asanOpen, setAsanOpen]}
        onComplete={(data) => {
          setLimit(data)
        }}
        status={status}
        errorend={error}
        handleSigning={async () => ({
          files: [
            {
              name: `biznes_kart_${moment().format('DD.MM.YYYY')}.json`,
              mimeType: 'application/json',
              encodedBytes: arrayBufferToBase64(getValues()),
            },
          ],
        })}
      />
      <CustomResult
        icon={<ModalQuestionIco />}
        text={t('businessCards.sureLimitedCard')}
        buttons={[
          {
            label: t('home.no'),
            type: 'default',
            onClick: closeModal,
          },
          {
            label: t('home.yes'),
            type: 'primary',
            onClick: () => {
              setAsanOpen(true)
              closeModal()
            },
          },
        ]}
      />
    </>
  )
}

export default AssignLimit
